import { Link } from 'react-router-dom';
import { categories } from '@/mocks/comics';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-background-900">
      <div className="w-full px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <h4 className="text-lg font-heading font-bold text-primary-400 mb-4">
              皮皮漫画
            </h4>
            <p className="text-sm text-background-200 leading-relaxed">
              皮皮漫画🎯提供韩漫、日漫、国漫等多种类型漫画在线免费阅读。每日更新，高清画质，流畅阅读体验。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">
              漫画分类
            </h4>
            <div className="flex flex-col gap-2">
              {categories.filter(c => c.key !== 'all').map(cat => (
                <Link
                  key={cat.key}
                  to={`/category/${cat.key}`}
                  className="text-sm text-background-300 hover:text-primary-400 transition-colors"
                >
                  皮皮漫画{cat.label}
                </Link>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">
              快速链接
            </h4>
            <div className="flex flex-col gap-2">
              <Link to="/" className="text-sm text-background-300 hover:text-primary-400 transition-colors">
                首页
              </Link>
              <Link to="/category/kr" className="text-sm text-background-300 hover:text-primary-400 transition-colors">
                分类浏览
              </Link>
              <Link to="/about" className="text-sm text-background-300 hover:text-primary-400 transition-colors">
                关于我们
              </Link>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">
              热门标签
            </h4>
            <div className="flex flex-wrap gap-2">
              {['恋爱', '热血', '奇幻', '战斗', '校园', '搞笑', '修仙', '冒险', '穿越', '霸总'].map(tag => (
                <span
                  key={tag}
                  className="px-3 py-1 text-xs bg-background-700 text-background-200 rounded-full hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer"
                >
                  {tag}
                </span>
              ))}
            </div>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-700 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-400">
            &copy; {currentYear} 皮皮漫画 - 皮皮漫画韩漫与皮皮漫画日漫 | 皮皮漫画国漫类型大全
          </p>
          <p className="text-xs text-background-400">
            本站所有漫画均来自网络，版权归原作者所有
          </p>
        </div>
      </div>
    </footer>
  );
}